import * as React from "react";
import classnames from "classnames";
import { SelectionBoxRadio } from "@grandvisionhq/common";
/* empty css                            */
import { TileLayout } from "../../../../../../../../components/TileLayout/modules/EcommContent/components/TileLayout/TileLayout.js";
const SunglassesRxableSelect = ({
  className,
  items,
  selectedValue,
  onChange
}) => {
  return /* @__PURE__ */ React.createElement("fieldset", { className: classnames("sunglasses-rxable-select", className) }, items.map(({ value, label, iconName }) => {
    return /* @__PURE__ */ React.createElement(
      SelectionBoxRadio,
      {
        key: value,
        name: "sunglasses-rxable-select",
        value,
        checked: selectedValue === value,
        onChange: () => onChange(value),
        "data-t": value
      },
      /* @__PURE__ */ React.createElement(TileLayout, { title: label, iconName })
    );
  }));
};
export {
  SunglassesRxableSelect
};
//# sourceMappingURL=SunglassesRxableSelect.js.map
